import { Box, styled } from '@mui/material';

export const StyledHeader = styled(Box)(({ theme }) => ({
  zIndex: 40,
  width: '100%',
  minHeight: theme.spacing(6.25)
}));

export const Top = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingBottom: theme.spacing(2.5),
  position: 'relative',

  '.MuiAutocomplete-root': {
    minWidth: 200
  }
}));

export const DateNavigationContainer = styled(Box)(({ theme }) => ({
  minWidth: theme.spacing(40),
  justifySelf: 'end'
}));

export const PlanUnitSelectorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(4),
  flexWrap: 'wrap',
  maxWidth: theme.spacing(81.25)
}));
